import {Component, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {DOCUMENT, isPlatformBrowser, Location} from '@angular/common';
import {StatePersistenceService} from './service/state.persistence.service';
import {BehaviorSubject, Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {NavigationEnd, Router} from '@angular/router';
import {BreakpointObserver} from '@angular/cdk/layout';
import {PreviousRouteService} from './@shared/previous-route.service';
import {ImagePreloadService} from './service/image-preload.service';
import {BackgroundService} from './service/background.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

    private subscription: Subscription | undefined;
    static isBrowser: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    routerUrl: string;

    constructor(@Inject(DOCUMENT) public document: Document,
                @Inject(PLATFORM_ID) public platformId: any,
                private backgroundService: BackgroundService,
                private imagePreloadService: ImagePreloadService,
                private location: Location,
                private previousRouteService: PreviousRouteService,
                private bpObserver: BreakpointObserver,
                private router: Router,
                public state: StatePersistenceService) {

        AppComponent.isBrowser.next(isPlatformBrowser(platformId));
        state.headerCss = undefined;

        this.router.events.pipe(filter((event: any): boolean => event instanceof NavigationEnd)).subscribe((event: NavigationEnd): void => {
            this.routerUrl = (event.url) ? event.url : this.routerUrl;
            this.ngOnInit().then((): void => {});
        });
    }

    async ngOnInit(): Promise<void> {
        if (isPlatformBrowser(this.platformId)) {
            let result: boolean = this.bpObserver.isMatched('(orientation: landscape)');
            let orientation: string = (result) ? 'landscape' : 'portrait';

            let userAgent: string = navigator.userAgent;
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
                if (orientation.startsWith('landscape')) {
                    const y: number = window.scrollY || 0;
                    this.state.expansion = (y <= 30) ? '' : 'navbar-collapse';
                }
            }

            this.state.orientation = orientation;

            setTimeout((): void => {
                this.subscription = this.backgroundService.startBackgroundService().subscribe({
                    next: (uri: string): void => {
                        this.imagePreloadService.preloadImages([uri]).then((): void => {
                        }).catch(error => {
                            console.error('Error preloading images:', error);
                        });
                    },
                    error: (error): void => {
                        console.error('Background service error:', error);
                    },
                });
            }, 10);
        }
    }

    @HostListener('window:scroll', ['$event'])
    onScroll(event): void {
        if (isPlatformBrowser(this.platformId)) {
            let result: boolean = this.bpObserver.isMatched('(orientation: landscape)');
            let orientation: string = (result) ? 'landscape' : 'portrait';

            let userAgent: string = navigator.userAgent;
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
                if (orientation.startsWith('landscape')) {
                    const y: number = window.scrollY || 0;
                    this.state.expansion = (y <= 30) ? '' : 'navbar-collapse';
                }
            }

            this.state.orientation = orientation;
        }
    }

    @HostListener('window:orientationchange', ['$event'])
    onTilt(event): void {
        if (isPlatformBrowser(this.platformId)) {
            let result: boolean = this.bpObserver.isMatched('(orientation: landscape)');
            let orientation: string = (!result) ? 'landscape' : 'portrait';

            let userAgent: string = navigator.userAgent;
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
                if (orientation.startsWith('landscape')) {
                    const y: number = window.scrollY || 0;
                    this.state.expansion = (y <= 30) ? '' : 'navbar-collapse';
                }
            }

            this.state.orientation = orientation;
        }
    }

    ngOnDestroy(): void {
        this.backgroundService.stopBackgroundService();
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
